/**
 * Selleasy cart upsell: show Size only in variant pickers
 * e.g. "Product / Washed Black / 26" → "26"
 *      "Washed Black / 26" → "26"
 */
(function () {
  var OPTION_SELECTORS = [
    '[widget^="widget#"] select option',
    '[widget^="widget#"] option',
    '.lb-addon select option',
    '.lb-fbt select option',
    '[class*="lb-"] select option',
    'cart-drawer select option',
    '#CartDrawer select option',
    '.cart-drawer select option',
    '.selleasy-variant-select option',
    '[data-selleasy] option'
  ].join(', ');

  function sizeOnlyLabel(text) {
    var value = (text || '').trim();
    if (!value.includes('/')) return null;

    var parts = value.split('/').map(function (part) {
      return part.trim();
    }).filter(Boolean);

    if (parts.length < 2) return null;

    // Shopify option titles are usually "Color / Size" — Size is last
    return parts[parts.length - 1];
  }

  function cleanOptionText(option) {
    if (!option || option.dataset.cleaned === 'true') return;

    var sizeLabel = sizeOnlyLabel(option.textContent);
    if (!sizeLabel) return;

    option.textContent = sizeLabel;
    option.dataset.cleaned = 'true';
  }

  function cleanSelleasyOptions() {
    document.querySelectorAll(OPTION_SELECTORS).forEach(cleanOptionText);
  }

  var scheduled = false;
  function scheduleClean() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      cleanSelleasyOptions();
    });
  }

  function init() {
    cleanSelleasyOptions();

    var observer = new MutationObserver(scheduleClean);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
